import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {IconDefinition} from '@fortawesome/fontawesome-common-types';
import {faCheck, faCircle} from '@fortawesome/free-solid-svg-icons';
import {Yii} from 'libraries/interfaces/Yii';

export enum EDefaultStatus {
    Default = "default"
}

export interface IStatusColorationRule {
    green?: string;
    red?: string;
    grey?: string;
    orange?: string;
}

@Component({
    selector: 'status-tag',
    template: `
        <fa-layers [title]="iconLabel" *ngIf="mode === 'icon' || mode === 'both'">
            <fa-icon [icon]="circle"
                     [ngClass]="{
                    'circle': true,
                    'confirm': statusColorationRule.green === status,
                    'cancel': statusColorationRule.grey === status,
                    'actionRequired': statusColorationRule.red === status,
                    'unableToConfirm': statusColorationRule.orange === status
                }"
                     transform="grow-5"></fa-icon>
            <fa-icon *ngIf="icons[status] || icons.default" [icon]="icons[status] || icons.default"
                     class="status"
                     transform="shrink-5"></fa-icon>
        </fa-layers>

        <span class="label-status" *ngIf="mode === 'label' || mode === 'both'">
            <span *ngIf="label" [class.break-line]="breakLine">{{ label }} <br/></span>
            <strong [ngClass]="{
                    'confirm': statusColorationRule.green === status,
                    'cancel': statusColorationRule.grey === status,
                    'actionRequired': statusColorationRule.red === status,
                    'unableToConfirm': statusColorationRule.orange === status
                }">{{ statusTranslated }}</strong>
        </span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        .break-line {
            display: block;
        }

        .icon-status, strong, fa-icon {
            color: #31708f;
        }

        .icon-status {
            font-size: 75%;
        }

        .icon-status i.fa-stack-2x {
            font-size: 2em;
        }

        .icon-status i.fa-stack-1x {
            font-size: 1em;
        }

        fa-icon.circle {
            transform: scale(1.5);
        }

        fa-icon.status {
            color: white;
        }

        .icon-status.OK, strong.OK, fa-icon.OK,
        .icon-status.confirm, strong.confirm, fa-icon.confirm {
            color: #3c763d;
        }

        .icon-status.cancel, strong.cancel, fa-icon.cancel {
            color: #707070;
        }

        .icon-status.Danger, strong.Danger, fa-icon.Danger,
        .icon-status.actionRequired, strong.actionRequired, fa-icon.actionRequired {
            color: #a94442;
        }

        .icon-status.unableToConfirm, strong.unableToConfirm, fa-icon.unableToConfirm {
            color: #f88000;
        }
    `]

})

export class StatusTagComponent<TStatus extends EDefaultStatus> {

    @Input()
    public mode: 'icon' | 'label' | 'both' = 'icon';

    @Input()
    public status: TStatus;

    @Input()
    public statusColorationRule: IStatusColorationRule = {
        green: "confirm",
        red: "actionRequired",
        grey: "cancel",
        orange: "unableToConfirm",
    };

    @Input()
    public label: string = Yii.t('wui-shared-js', "Statut du dossier :");

    @Input()
    public icons: { [status: string]: IconDefinition };

    @Input()
    public readonly statusTranslated: string;

    @Input()
    public readonly iconLabel: string;

    @Input()
    public readonly breakLine: boolean = false;

    public readonly circle: IconDefinition = faCircle;
}
